module.exports = __webpack_public_path__ + "assets/algoritmo_mobile_oculto.05091bcb.svg";